import { memo } from "react";
import { TeleconsultoriaDateFilter } from "../../shared/components/TeleconsultoriaDateFilter";
import { useTeleconsultoriaDateRange } from "../../shared/hooks/useTeleconsultoriaDateRange";
import { useTeleconsultorRowActions } from "../hooks/useTeleconsultorRowActions";
import { useUpcomingTeleconsultorias } from "../hooks/useUpcomingTeleconsultorias";
import { ActivitySectionFrame } from "./ActivitySectionFrame";
import { BookedTeleconsultoriaRowCard } from "./BookedTeleconsultoriaRowCard";

/**
 * "Próximas teleconsultorias" do profissional da prestadora, por dia (ou mês):
 * consultas nas minhas agendas + convites que aceitei.
 * Cada linha já traz a ação certa: "Iniciar teleconsultoria" ou Aceitar/Recusar.
 */
export const UpcomingTeleconsultoriasSection = memo(function UpcomingTeleconsultoriasSection() {
  const range = useTeleconsultoriaDateRange("day");
  const { rows, isLoading, hasError, reload } = useUpcomingTeleconsultorias(range);
  const { canStart, pendingInviteOf } = useTeleconsultorRowActions();

  return (
    <ActivitySectionFrame
      title="Próximas teleconsultorias"
      subtitle="Suas consultas de teleconsultoria e os convites que você aceitou."
      toolbar={<TeleconsultoriaDateFilter range={range} />}
      isLoading={isLoading}
      hasError={hasError}
      errorText="Não foi possível carregar as teleconsultorias."
      isEmpty={!rows.length}
      emptyText={
        range.mode === "day"
          ? "Nenhuma teleconsultoria neste dia."
          : "Nenhuma teleconsultoria neste mês."
      }
      onRefresh={reload}
    >
      {rows.map((row) => (
        <BookedTeleconsultoriaRowCard
          key={row.appointmentId}
          row={row}
          canStart={canStart(row)}
          pendingInvite={pendingInviteOf(row)}
        />
      ))}
    </ActivitySectionFrame>
  );
});
